import React from 'react'
import { useStateFields } from '../../store/hooks';
import { Link } from 'react-router-dom';
import './Sidebar.css'
import { AiOutlineClose, AiOutlineUser } from 'react-icons/ai'
import { GrTransaction, GrUserAdmin, GrUnorderedList, GrInstagram } from "react-icons/gr"
import { MdLogout, MdOutlineEdit, MdCardGiftcard } from "react-icons/md"
import { useState, useEffect } from 'react';
import { getLogoutFunctionality, isAdmin, token_url, globalLoader, Platform } from '../../script/util.js';
import { openExternalApp } from '@egreact/shared';
import Popup from '../Popup/Popup.js'
import useReferralLive from '../../script/useReferralLive'

const Sidebar = () => {
  const { isOpen, setisOpen } = useStateFields(['isOpen']);
  const isReferralLive = useReferralLive();
  const [user, setUser] = useState("loading..")
  const [loading, setLoading] = useState(false)
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false)
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('auth_dict')))
  }, [])

  const handleLogoutClick = () => {
    if (loading) return
    setLogoutConfirmOpen(true)
  }

  const handleLogoutConfirm = () => {
    setLoading(true)
    getLogoutFunctionality()
  }

  const handleLogoutCancel = () => {
    if (loading) return
    setLogoutConfirmOpen(false)
  }
  var inst_url = 'https://www.instagram.com/eventgraphia/'
  if (Platform.isWG) {
    inst_url = 'https://www.instagram.com/wedgraphia/'
  }
  return (
    <>
      <Popup isOpen={logoutConfirmOpen} onClose={handleLogoutCancel}>
        <div style={{ padding: '10px 10px 0px 10px' }}>
        <>
              <div style={{ fontWeight: 700, color: 'black', fontSize: '1.05rem', marginBottom: 12, textAlign: 'left' }}>
                Confirm Logout
              </div>
              <div style={{ color: 'black', marginBottom: 18, textAlign: 'left' }}>
                Are you sure you want to log out?
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                <button
                  type="button"
                  onClick={handleLogoutCancel}
                  style={{
                    border: '1px solid #ccc',
                    background: 'white',
                    borderRadius: 8,
                    padding: '10px 16px',
                    cursor: 'pointer',
                    color: 'black',
                    fontWeight: 600,
                    flex: '1 1 auto',
                    minWidth: 80,
                    fontSize: '1rem',
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleLogoutConfirm}
                  disabled={loading}
                  style={{
                    border: '1px solid #E11D48',
                    background: '#E11D48',
                    borderRadius: 8,
                    padding: '10px 16px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    color: 'white',
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8,
                    flex: '1 1 auto',
                    minWidth: 80,
                    fontSize: '1rem',
                  }}
                >
                  Logout{loading && globalLoader('md')}
                </button>
              </div>
            </>
        </div>
      </Popup>
      {isOpen &&
        <>
          <div className="sidebar-overlay" onClick={() => setisOpen(false)}></div>
          <div className="sidebar">
            <AiOutlineClose className='close-icon-sidebar' onClick={() => { setisOpen(false) }} />
            <div className="userDetails">
              <div className="top-sidebar">
                <li className="sidebar-sub-heading">Account</li>

                {/* <li className="sub-links-sidebar"><p><AiOutlineUser />{user.eventGraphiaName}</p></li> */}

              </div>
              <div className="middle-sidebar">
                {/* <li className="sidebar-sub-heading">Profile</li> */}
                <Link to='/account' onClick={() => setisOpen(false)}>
                  <li className="sub-links-sidebar pointer">
                    <p>
                      <AiOutlineUser />{user.eventGraphiaName}
                      <MdOutlineEdit />
                    </p>
                  </li>
                </Link>
                {/* <li className="sub-links-sidebar pointer" onClick={() => window.location = token_url(`${process.env.REACT_APP_STAG_URL}/transactions`)}><p><GrTransaction />My Transactions</p></li> */}
              </div>
              <div className="bottom-sidebar">
                <li className="sidebar-sub-heading">Others</li>
                {isReferralLive && (
                  <Link to={`/referral?utm_source=dashboard&utm_campaign=referral&customer_id=${user?.eventGraphiaId}`} onClick={() => setisOpen(false)}>
                    <li className="sub-links-sidebar sidebar-refer refer-sheen pointer">
                      <p>
                        <MdCardGiftcard className="sidebar-refer-icon" />
                        Refer &amp; Earn
                        <span className="sidebar-refer-badge">EG Coins</span>
                      </p>
                    </li>
                  </Link>
                )}
                <li className="sub-links-sidebar pointer" onClick={() => openExternalApp(inst_url)}><p><GrInstagram />Our Instagram</p></li>

                <li className="sub-links-sidebar pointer" onClick={() => window.location = token_url(`${process.env.REACT_APP_STAG_URL}/terms`)}><p><GrUnorderedList />Terms & Conditions</p></li>

                <li className="sub-links-sidebar pointer" onClick={() => window.location = token_url(`${process.env.REACT_APP_STAG_URL}/privacy`)}><p><GrUserAdmin />Privacy Policy</p></li>

                <li onClick={handleLogoutClick} className="sub-links-sidebar pointer"><p><MdLogout />Logout{loading && globalLoader('md')}</p></li>

              </div>
            </div>
          </div>
        </>}
    </>

  )
}

export default Sidebar